import React, { useState} from 'react'
import { Table,Container,Row,Card,CardHeader,CardBody,Spinner, Button, Col } from "reactstrap";
import {vipTables, vipTablesOnline} from 'network/ApiAxiosTickets'
import DatePicker from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css";
import { v4 as uuid } from 'uuid';
import Header from 'components/Headers/Header';

const VipTablesReport = () => {
    const [startDate, setStartDate] = useState(null);
    const [data, setData] = useState({});
    const [dataOnline, setDataOnline] = useState({});
    const [spin, setSpin] = useState(false);

    const role = JSON.parse(localStorage.getItem('user')).role

    const onChange = (date) => {
        const start = date;
        setStartDate(addHours(2,start));
    };

    function addHours(numOfHours, date = new Date()) {
    date.setHours(date.getHours() + numOfHours);
    return date;
    }

    const getReport = async(e)=>{
        //e.preventDefault()
        setData({})
        setDataOnline({})
        if(startDate){
            setSpin(true)
            const res = await vipTables(startDate)
            //console.log(res.data)
            if(res.data.success) {
                setData(res.data)
                getOnlineTables()

            }else{
                alert("No VIP tables sold by the sellers on this date")
                getOnlineTables()
            }

            

            if(!res.data.success){
                setData({})
            }
            
        }
    }

    const getOnlineTables=async()=>{
        const ress = await vipTablesOnline(startDate)
            //console.log(ress.data.success)
            if(ress.data.success) {
                setDataOnline(ress.data)
                setSpin(false)
            }else{
                setSpin(false)
                alert("No VIP tables sold online on this date")
            }
            if(!ress.data.success){
                setDataOnline({})
            }
    }

    return (
    <>
        {role == 'admin' && <Header/>}
        <Container fluid>
            <Row>
                <div className="col mt-6">
                    <Card className="shadow">
                        <CardHeader className="border-0">
                            <h2 className=' float-right'>Reports</h2>
                            <Row>
                                <Col>
                                    <label>Date:</label>
                                    <DatePicker
                                    //selected={startDate}
                                    selected={startDate}
                                    onChange={onChange}
                                    startDate={startDate}
                                    dateFormat="dd/MM/yyyy"
                                    calendarStartDay={1}
                                    /> 
                                </Col>
                            </Row>   
                            <Button onClick={getReport}> GO </Button>
                            {spin ? 
                                <Spinner
                                    className="ml-3"
                                    color="primary"
                                >
                                    Loading...
                                </Spinner>
                                :null
                            }
                        </CardHeader>
                        <CardBody>
                            
                            <>
                            <h3>Tables Sold</h3>
                            <Table className="align-items-center table-flush" hover responsive striped>
                                <thead className="thead-light">
                                    <tr>
                                        <th scope="col">Event</th>
                                        <th scope="col">Client</th>
                                        <th scope="col" className='text-center'>Seller</th>
                                        <th scope="col" className='text-center'>Bottle</th>
                                        <th scope="col" className='text-center'>Quantity</th>
                                        <th scope="col" className='text-center'>Collected</th>
                                        <th scope="col" className='text-center'>Checked In</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    
                                    {
                                        data.vipTableArr && data.vipTableArr[0].map((row)=>
                                        {
                                            console.log(row)
                                            if(row){return <tr key={uuid()} >
                                                        <th scope="col" >{row.event}</th>
                                                        <th scope="col">{row.clientName}</th>
                                                        <th scope="col" className='text-center'>
                                                            {row.Seller}
                                                        </th>
                                                        <th scope="col" className='text-center'>
                                                            {row.bottle}
                                                        </th>
                                                        <th scope="col" className='text-center'>
                                                            {row.qt}
                                                        </th>
                                                        <th scope="col" className='text-center'>
                                                            {row.Collected ? "True" : "False"}
                                                        </th>
                                                        <th scope="col" className='text-center'>
                                                            -
                                                        </th>
                                                    </tr>}
                                        })
                                    }

                                    {
                                        dataOnline.vipTableOnlineArr && dataOnline.vipTableOnlineArr[0].map((roww)=>
                                        {console.log(dataOnline.vipTableOnlineArr)
                                                return  <tr key={uuid()}>
                                                            <th scope="col">{roww.event}</th>
                                                            <th scope="col">{roww.clientName}</th>
                                                            <th scope="col" className='text-center'>
                                                                Online
                                                            </th>
                                                            <th scope="col" className='text-center'>
                                                                {roww.bottle}
                                                            </th>
                                                            <th scope="col" className='text-center'>
                                                                {roww.qt}
                                                            </th>
                                                            <th scope="col" className='text-center'>
                                                                True
                                                            </th>
                                                            <th scope="col" className='text-center'>
                                                                {roww.checkin ? "True" : "False"}    
                                                            </th>
                                                        </tr>
                                        })
                                    }
                                </tbody>
                            </Table>
                            </>
                        </CardBody>
                    </Card>
                </div>
            </Row>
        </Container>
    </>
    )
}

export default VipTablesReport
